import { render, staticRenderFns } from "./forms-list-categories.vue?vue&type=template&id=436c3d3e&"
import script from "./forms-list-categories.vue?vue&type=script&lang=js&"
export * from "./forms-list-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports